import ModeButton from 'components/Buttons/ModeButton';
import BaseCard from 'components/Cards/BaseCard';
import { Col, Form, Row } from 'react-bootstrap';
import {
  CARD_CLASS_NAMES,
  REPORTING_MODES_OPTIONS,
  SAMPLING_MODES_OPTIONS,
} from '../../../../config/floodDeviceConfig';

export default function ModesCard({ deviceSettings, setDeviceSettings, enabled }) {
  return (
    <BaseCard
      className={`shadow-sm ${CARD_CLASS_NAMES.card}`}
      header="Modes"
      headerClassName={CARD_CLASS_NAMES.cardHeader}
      bodyClassName={`d-flex flex-column gap-3 ${CARD_CLASS_NAMES.cardBody}`}
    >
      <Row className="align-items-center g-3">
        <Col lg={5} className="d-flex align-items-center gap-2">
          <Form.Label className="fw-semibold mb-0">Reporting Modes</Form.Label>
        </Col>
        <Col lg={7}>
          <ModeButton
            options={Object.values(REPORTING_MODES_OPTIONS)}
            onChange={(value) => {
              setDeviceSettings((prev) => ({
                ...prev,
                mode: parseInt(
                  Object.keys(REPORTING_MODES_OPTIONS).find(
                    (key) => REPORTING_MODES_OPTIONS[key] === value,
                  ),
                ),
              }));
            }}
            selectedOption={REPORTING_MODES_OPTIONS[deviceSettings?.mode]}
            enabled={enabled}
          />
        </Col>
      </Row>
      <Row className="align-items-center g-3">
        <Col lg={5} className="d-flex align-items-center gap-2">
          <Form.Label className="fw-semibold mb-0">Sampling Modes</Form.Label>
        </Col>
        <Col lg={7}>
          <ModeButton
            options={Object.values(SAMPLING_MODES_OPTIONS)}
            onChange={(value) => {
              setDeviceSettings((prev) => ({
                ...prev,
                samp: parseInt(
                  Object.keys(SAMPLING_MODES_OPTIONS).find(
                    (key) => SAMPLING_MODES_OPTIONS[key] === value,
                  ),
                ),
              }));
            }}
            selectedOption={SAMPLING_MODES_OPTIONS[deviceSettings?.samp]}
            enabled={enabled}
          />
        </Col>
      </Row>
    </BaseCard>
  );
}
